// EasyPlayer 加载器插件
export default {
  install(Vue) {
    // 确保脚本只加载一次
    if (window.customElements && window.customElements.get('easy-player')) {
      return;
    }

    // 设置 EasyPlayer 的 wasm 文件路径
    window.EasyPlayerVersion = {
      wasm: '/static/video/EasyPlayer.wasm',
      player: '/static/video/EasyPlayer.swf'
    };

    var script = document.createElement('script');
    script.src = '/static/video/EasyPlayer-element.min.js';
    document.head.appendChild(script);
  }
}



// WEBPACK FOOTER //
// ./src/Common/EasyPlayerLoader.js